<template>
    <div>
        <el-table :data="detail.toDocument">

            <el-table-column label="文件名" prop="title"></el-table-column>

            <el-table-column label="描述" prop='description'></el-table-column>

            <el-table-column label="创建人" prop='createUser'></el-table-column>

            <el-table-column label="上传时间" prop='createTime'></el-table-column>
        </el-table>
    </div>
</template>

<script>
export default {
    props:{
        detail:Object,
    },
}
</script>

<style lang="scss" scoped>
    .el-form-item {
        img {
            vertical-align: middle;
            margin-left: 5px;
        }
    }
</style>

